export const isLoading = state => state.adminReducer.venue.isLoading

export const isSuccess = state => state.adminReducer.venue.isSuccess

export const venue = state => state.adminReducer.venue.venue

export const errors = state => state.adminReducer.venue.errors

export const permissions = state => state.adminReducer.venue.permissions
